/**
 * Dutch labels for media-chrome's own controls. media-chrome 4.19 ships
 * de/es/en but no nl; keys must match media-chrome/lang/en.js exactly.
 */
export const mediaChromeNl = {
    "Start airplay": "AirPlay starten",
    "Stop airplay": "AirPlay stoppen",
    Audio: "Audio",
    Captions: "Ondertitels",
    "Enable captions": "Ondertitels aanzetten",
    "Disable captions": "Ondertitels uitzetten",
    "Start casting": "Casten starten",
    "Stop casting": "Casten stoppen",
    "Enter fullscreen mode": "Volledig scherm",
    "Exit fullscreen mode": "Volledig scherm sluiten",
    Mute: "Geluid uit",
    Unmute: "Geluid aan",
    Loop: "Herhalen",
    "Enter picture in picture mode": "Zweefvenster openen",
    "Exit picture in picture mode": "Zweefvenster sluiten",
    Play: "Afspelen",
    Pause: "Pauzeren",
    "Playback rate": "Afspeelsnelheid",
    "Playback rate {playbackRate}": "Afspeelsnelheid {playbackRate}",
    Quality: "Kwaliteit",
    "Seek backward": "Terugspoelen",
    "Seek forward": "Vooruitspoelen",
    Settings: "Instellingen",
    Auto: "Auto",
    "audio player": "audiospeler",
    "video player": "videospeler",
    volume: "volume",
    seek: "zoeken",
    "closed captions": "ondertitels",
    "current playback rate": "huidige afspeelsnelheid",
    "playback time": "afspeeltijd",
    "media loading": "media wordt geladen",
    settings: "instellingen",
    "audio tracks": "audiosporen",
    quality: "kwaliteit",
    play: "afspelen",
    pause: "pauzeren",
    mute: "geluid uit",
    unmute: "geluid aan",
    "chapter: {chapterName}": "hoofdstuk: {chapterName}",
    live: "live",
    Off: "Uit",
    "start airplay": "airplay starten",
    "stop airplay": "airplay stoppen",
    "start casting": "casten starten",
    "stop casting": "casten stoppen",
    "enter fullscreen mode": "volledig scherm",
    "exit fullscreen mode": "volledig scherm sluiten",
    "enter picture in picture mode": "zweefvenster openen",
    "exit picture in picture mode": "zweefvenster sluiten",
    "seek to live": "naar live springen",
    "playing live": "live",
    "seek back {seekOffset} seconds": "{seekOffset} seconden terug",
    "seek forward {seekOffset} seconds": "{seekOffset} seconden vooruit",
    "Network Error": "Netwerkfout",
    "Decode Error": "Decodeerfout",
    "Source Not Supported": "Bron niet ondersteund",
    "Encryption Error": "Versleutelingsfout",
    "A network error caused the media download to fail.": "Door een netwerkfout kon de media niet worden gedownload.",
    "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.":
        "Door een mediafout is het afspelen gestopt. De media is mogelijk beschadigd of je browser ondersteunt dit formaat niet.",
    "An unsupported error occurred. The server or network failed, or your browser does not support this format.":
        "Er is een onbekende fout opgetreden. De server of het netwerk faalde, of je browser ondersteunt dit formaat niet.",
    "The media is encrypted and there are no keys to decrypt it.": "De media is versleuteld en er zijn geen sleutels om deze te ontsleutelen.",
    hour: "uur",
    hours: "uur",
    minute: "minuut",
    minutes: "minuten",
    second: "seconde",
    seconds: "seconden",
    "{time} remaining": "nog {time}",
    "{currentTime} of {totalTime}": "{currentTime} van {totalTime}",
    "video not loaded, unknown time.": "video niet geladen, tijd onbekend.",
}
